// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -------------------------------
   MDBDataTable Custom Border Styles
-------------------------------- */

/* Outer table border */
.mdb-datatable table.table-bordered {
  border: 1px solid #ced4da !important;
  border-collapse: collapse !important;
}

/* Header cells */
.mdb-datatable table.table-bordered thead th {
  border: 1px solid #ced4da !important;
  background-color: #f8f9fa;
  font-weight: 600;
}

/* Body cells */
.mdb-datatable table.table-bordered tbody td {
  border: 1px solid #dee2e6 !important;
  padding: 8px 12px;
}

/* Hover rows */
.mdb-datatable table tbody tr:hover {
  background-color: #f5f7fa;
}

/* First column and last column borders */
.mdb-datatable table.table-bordered td:first-child,
.mdb-datatable table.table-bordered th:first-child {
  border-left: 1px solid #ced4da !important;
}

.mdb-datatable table.table-bordered td:last-child,
.mdb-datatable table.table-bordered th:last-child {
  border-right: 1px solid #ced4da !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CourseProgramNames/mdb-table-custom.css"],"names":[],"mappings":"AAAA;;kCAEkC;;AAElC,uBAAuB;AACvB;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,0CAA0C;AAC5C","sourcesContent":["/* -------------------------------\r\n   MDBDataTable Custom Border Styles\r\n-------------------------------- */\r\n\r\n/* Outer table border */\r\n.mdb-datatable table.table-bordered {\r\n  border: 1px solid #ced4da !important;\r\n  border-collapse: collapse !important;\r\n}\r\n\r\n/* Header cells */\r\n.mdb-datatable table.table-bordered thead th {\r\n  border: 1px solid #ced4da !important;\r\n  background-color: #f8f9fa;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Body cells */\r\n.mdb-datatable table.table-bordered tbody td {\r\n  border: 1px solid #dee2e6 !important;\r\n  padding: 8px 12px;\r\n}\r\n\r\n/* Hover rows */\r\n.mdb-datatable table tbody tr:hover {\r\n  background-color: #f5f7fa;\r\n}\r\n\r\n/* First column and last column borders */\r\n.mdb-datatable table.table-bordered td:first-child,\r\n.mdb-datatable table.table-bordered th:first-child {\r\n  border-left: 1px solid #ced4da !important;\r\n}\r\n\r\n.mdb-datatable table.table-bordered td:last-child,\r\n.mdb-datatable table.table-bordered th:last-child {\r\n  border-right: 1px solid #ced4da !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
